import _Model from "./_Model";


export default class Rack extends _Model {
  constructor(json) {
    super(json);
    this.id = Rack.getOrDefault(json, 'id', '');
    this.height = Rack.getMappedOrDefault(json, 'height', 0.0, v => parseFloat(v));
    this.width = Rack.getMappedOrDefault(json, 'width', 0.0, v => parseFloat(v));
    this.maxIoModules = Rack.getMappedOrDefault(json, 'maxIoModules', 0, v => parseInt(v));
    this.maxPowerSupplies = Rack.getMappedOrDefault(json, 'maxPowerSupplies', 0, v => parseInt(v));
    this.powerSupplyType = Rack.getOrDefault(json, 'powerSupplyType', null);
    this.ruggedization = Rack.getOrDefault(json, 'ruggedization', null);
    this.rackProtocolType = Rack.getOrDefault(json, 'rackProtocolType', null);
    this.compatiblePacTypes = Rack.getMappedOrDefault(json, 'compatiblePacTypes', [], data => (data || []).map(i => i));
    // Need to investigate why the MsxRackDTO sends the value with a capital letter.
    this.xBusOnlySlots = Rack.getMappedOrDefault(json, 'XBusOnlySlots', [], data => (data || []).map(i => parseInt(i)));
  }
}
